@if (selectedLogon?.error) {
<pl-error-load-user-info messageType="DELETE_USER"></pl-error-load-user-info>
} @else {
<seds-modal>
  <div header>Exclusão de usuário</div>
  <div content>
    <div class="dialog-content__fade-in">
      @if (isDeleting && (selectSuccessDeleteUser$ | async)) {
      <pl-alert @fadeIn color="success" display="inline">
        <span header>Usuário excluído com sucesso!</span>
      </pl-alert>
      } @if (selectErrorDeleteUser$ | async) {
      <pl-alert color="error" display="block" @fadeIn>
        <span header>Não foi possível EXCLUIR o usuário.</span>
        <span content
          >Estamos trabalhando para resolver esse problema. Por favor, tente
          novamente mais tarde e, se o erro persistir, entre em contato com a
          nossa equipe de atendimento.</span
        >
      </pl-alert>
      } @if (!isDeleting && !(selectErrorDeleteUser$ | async)) {
      <p class="dialog-content__description" @fadeIn>
        O usuário abaixo será EXCLUÍDO e não terá mais acesso ao Menu de
        Produtos.
      </p>
      } @if (!isDeleting && !(selectErrorDeleteUser$ | async)) {
      <pl-alert @fadeIn color="warning" display="inline">
        <span header class="alert-delete"
          >Atenção essa ação não poderá ser desfeita.</span
        >
      </pl-alert>
      } @if (selectedLogon$ | async; as data) {
      <section class="dialog-content__box">
        <ul class="dialog-content__box__list">
          <li class="dialog-content__box__list__item">
            Nome:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': data?.fullname,
                'dialog-content__box__list__item--italic': !data?.fullname
              }"
              >{{ data?.fullname || "Não cadastrado" }}</span
            >
          </li>
          <li>
            {{ data?.document?.documentCountry !== "BRA" ? "RNM" : "CPF" }}:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold':
                  data?.document?.documentId,
                'dialog-content__box__list__item--italic':
                  !data?.document?.documentId
              }"
              >{{
                (data?.document?.documentId | document : true) ||
                  "Não cadastrado"
              }}</span
            >
          </li>
          <li>
            Logon:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': data?.logon,
                'dialog-content__box__list__item--italic': !data?.logon
              }"
              >{{ data?.logon || "Não cadastrado" }}</span
            >
          </li>
          <li>
            E-mail:
            <label
              [ngClass]="{
                'dialog-content__box__list__item--bold':
                  data?.alternativeEmail?.email,
                'dialog-content__box__list__item--italic':
                  !data?.alternativeEmail?.email
              }"
              >{{ data?.alternativeEmail?.email || "Não cadastrado" }}</label
            >
          </li>
          <li>
            Celular:
            <span
              [ngClass]="{
                'dialog-content__box__list__item--bold': data?.phone,
                'dialog-content__box__list__item--italic': !data?.phone
              }"
              >{{ data?.phone?.areaCode }}
              {{ data?.phone?.phoneNumber || "Não cadastrado" }}</span
            >
          </li>
        </ul>
      </section>
      }
    </div>
  </div>
  <div class="footer w-100 d-flex justify-content-end" footer>
    @if (selectedLogon$ | async) {
    <div mat-dialog-actions class="buttons-wrapper">
      @if (!(selectErrorDeleteUser$ | async) && (selectSuccessDeleteUser$ |
      async) === false) {
      <seds-flat-button
        [size]="smallButton"
        class="buttons-wrapper__btn-cancelar"
        data-test="btn-cancelar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        mat-dialog-close
        plAnalyticsButton
        title="Cancelar"
      ></seds-flat-button>
      } @if (!(selectErrorDeleteUser$ | async) && (selectSuccessDeleteUser$ |
      async) === false) {
      <seds-basic-button
        [size]="smallButton"
        [disabled]="isDeleting"
        (click)="deleteUser()"
        class="buttons-wrapper__btn-delete-user"
        data-test="btn-delete-user"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
        title="Excluir"
      ></seds-basic-button>
      } @if ((selectErrorDeleteUser$ | async) || (selectSuccessDeleteUser$ |
      async)) {
      <seds-basic-button
        [size]="smallButton"
        class="buttons-wrapper__btn-concluir"
        data-test="btn-concluir"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        mat-dialog-close
        plAnalyticsButton
        title="Concluir"
      ></seds-basic-button>
      }
    </div>
    }
  </div>
</seds-modal>

}
